<mat-form-field appearance="fill">
  <input
    class="datepicker-trigger"
    readonly
    matInput
    [matDatepicker]="picker"
    (click)="picker.open()"
    [max]="maxDate"
    [min]="minDate"
    [value]=value
    (dateChange)="onChange($event.value)"
  />
  <mat-datepicker #picker></mat-datepicker>
</mat-form-field>

<!-- <mat-icon
  (click)="picker.open()"
  class="chev-icon"
  svgIcon="chev-down"
></mat-icon> -->
